<!--
 * @Author: MX
 * @Date: 2021-01-15 15:12:31
 * @Description:下载中心
-->
<template>
  <div class="exportDownloadDialog">
    <el-dialog :title="$lang('下载中心')" :width="'900px'"
    @close="dialogClose" :close-on-click-modal="false" :visible="dialogExportDownVisible" @opened="dialogOpened">
      <div class="main-top">
        <el-button type="primary" icon="iconfont iconchaxun" class="h32" @click="searchFun">{{$lang('查询')}}</el-button>
      </div>
      <div class="main-table" style="margin-top:10px">
        <JmsTableScroll
          :option="listOpt"
          :data="tableList"
          :page="page"
          :table-loading="loading"
          @size-change="sizeChange"
          @current-change="currentChange"
        >
          <template slot="menu" slot-scope="{ row }">
            <el-button type="text" @click="downLoadFile(row)" v-if="row.finishOrNot === '1'">{{$lang('下载')}}</el-button>
          </template>
        </JmsTableScroll>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import { downloadCenterList, downloadCenterReqDel, updateFinishDownLoad } from '@api/module/customer'
import { RESPONSE_SUCCESS } from '@constants'
import dayjs from 'dayjs'

export default {
  name: 'ExportDownloadDialog',
  props: {
    dialogExportDownVisible: {
      type: Boolean,
      default: false,
    },
    moduleType: {
      type: String,
      default: '',
    },
  },
  components: {
    JmsTableScroll,
  },
  data() {
    return {
      COM_HTTP: {
        reqList: downloadCenterList,
        reqDel: downloadCenterReqDel,
      },
      delTitObj: {
        title: this.$lang('删除'),
        subTitle: this.$lang('你确定要删除该条数据吗？'),
        threeTitle: '',
      },
      tableList: [],
      loading: false, // 加载状态
      page: {
        // 分页配置
        current: 1,
        size: 100,
        total: 0,
        sizes: [
          50,
          100,
          200,
          500,
          1000,
        ],
      },
    }
  },
  computed: {
    listOpt() {
      return {
        fixHeight: 220,
        border: true,
        menu: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        menuWidth: 150,
        column: [
          {
            label: '模块名称',
            prop: 'moduleType',
            formatter: (row, value, label, column) => {
            //   console.log(map[row.moduleType])
              const map = {
                'my_order_qy': this.$lang('我的订单-网页下单'),
                'my_waybill_qy': this.$lang('我的运单'),
              }
              return map[row.moduleType]
            },
          },
          {
            label: '导出时间',
            prop: 'downTime',
          },
          {
            label: '导出状态',
            prop: 'finishOrNot',
            formatter: (row, value, label, column) => {
              const map = {
                '-1': '<i class="dot"></i> ' + this.$lang('下载失败'),
                '0': '<i class="dot oragin"></i> ' + this.$lang('下载中'),
                '1': '<i class="dot green"></i> ' + this.$lang('下载完成'),
              }
              return map[row.finishOrNot]
            },
          },
        ],
      }
    },
  },
  methods: {
    // 关闭
    dialogClose() {
      this.$emit('update:dialogExportDownVisible', false)
    },
    // 打开
    dialogOpened() {
      this.searchFun()
    },
    /**
    * @description 查询
    */
    async searchFun() {
      let searchFunTime = null
      clearTimeout(searchFunTime)
      this.loading = true
      // 获取定时器ID
      searchFunTime = setTimeout(async () => {
        const newParams = Object.assign({ current: this.page.current, size: this.page.size }, this.getParams())
        const res = await this.COM_HTTP.reqList(newParams)
        this.loading = false
        if (res.code === RESPONSE_SUCCESS) {
          this.tableList = res.data.records ? (this.formatList ? this.formatList(res.data) : res.data.records) : []
          this.page.total = res.data.total || 0
          this.page.current = res.data.current || 1
        } else {
          this.$message.error(res.msg)
        }
      }, 1000)
    },
    getParams() {
      const timeArr = () => {
        const now = new Date()
        return [dayjs(new Date().getTime() - 3 * 24 * 3600 * 1000).format('YYYY-MM-DD') + ' 00:00:00', dayjs(now.setHours(23, 59, 59)).format('YYYY-MM-DD HH:mm:ss')]
      }
      const time = timeArr()
      return {
        moduleNames: this.moduleType,
        downTimeStart: time[0],
        downTimeEnd: time[1],
      }
    },
    /**
    * @description 下载文件
    */
    async downLoadFile(row) {
      const { code, msg } = await updateFinishDownLoad({ id: row.infoId, downUrl: row.downUrl })
      // 211104,后端直接返回下载链接
      const rep = 'amp;'
      const str = row.downUrl
      const strData = str.replace(new RegExp(rep, 'g'), '')
      if (code === RESPONSE_SUCCESS) {
        const elink = document.createElement('a')
        elink.style.display = 'none'
        elink.href = strData
        elink.setAttribute('download', this.$lang(row.moduleName) + '.xls')
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
      } else {
        this.$message.error(msg)
      }
    },

    // 选择分页条数
    sizeChange(val) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
    },
    // 删除提示弹窗
    async rowDel(row, index) {
      this.$confirm(
        `
      <div class="comfirm-wrap">
        <i class="el-icon-warning"></i>
        <h3 class="comfirm-hd">${this.delTitObj.title}</h3>
      </div>
      <p class="comfirm-tit">${this.delTitObj.subTitle}</p>
      <p class="comfirm-tit sub-tit">${this.delTitObj.threeTitle}</p>
      `,
        '',
        {
          confirmButtonText: this.$lang('确定'),
          cancelButtonText: this.$lang('取消'),
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          customClass: 'comfirm-box',
          confirmButtonClass: 'h88',
          cancelButtonClass: 'h88 cancelBtn',
        }
      )
        .then(() => {
          this.deleteFun(row)
        })
        .catch(_ => {})
    },
    // 删除方法
    async deleteFun({ infoId }) {
      const res = await this.COM_HTTP.reqDel({ id: infoId })
      if (res.code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('删除成功'))
        this.searchFun()
      } else {
        this.$message.error(res.msg)
      }
    },
  },
}
</script>

<style lang="scss">
.exportDownloadDialog{
    .el-table__fixed,.el-table__fixed-right{
        height: 530px !important;
    }
}

</style>
